import { useTheme } from "@mui/material";
import { ChevronDown } from "lucide-react";
import { type FC, useState } from "react";
import { FolderPickerDrawer } from "web_myplann/Portfolio/Components/Redesign/Documents/FolderPickerDrawer";
import { withSelectedFolder } from "web_myplann/Portfolio/Helpers/withSelectedFolder";
import { FlatRowInput } from "web_myplann/Shared/Components/FlatRow/FlatRowInput";

type Props = {
	label: string;
	placeholder: string;
	value: string | null;
	onChange: (value: string | null) => void;
	folders: string[];
	isLast?: boolean;
};

export const FolderPicker: FC<Props> = ({
	label,
	placeholder,
	value,
	onChange,
	folders,
	isLast,
}) => {
	const { palette, iconSize } = useTheme();
	const [open, setOpen] = useState(false);

	return (
		<>
			<FlatRowInput
				label={label}
				placeholder={placeholder}
				value={value ?? ""}
				readOnly
				icon={<ChevronDown size={iconSize.md} color={palette.grey[400]} />}
				onClick={() => setOpen(true)}
				isLast={isLast}
			/>
			<FolderPickerDrawer
				open={open}
				onClose={() => setOpen(false)}
				folders={withSelectedFolder(folders, value)}
				selectedFolder={value}
				onSelect={(folder) => {
					onChange(folder);
					setOpen(false);
				}}
			/>
		</>
	);
};
